module.exports = __webpack_public_path__ + "img/PS.8396a118.svg";